export default __webpack_public_path__ + "static/media/rb_talent_not_found.7a87a096.svg";